/* istanbul ignore file -- @preserve */

import { ApolloLink, FetchResult, Observable, Operation } from '@apollo/client';
import { Consumer, createConsumer } from '@rails/actioncable';
import { print } from 'graphql';

import { cableURL } from 'utils/bff';

let cable: Consumer | undefined;

// Created on first use so no consumer (and no socket) exists unless a
// subscription actually runs.
function getConsumer(): Consumer {
  if (!cable) cable = createConsumer(cableURL);
  return cable;
}

export default function buildCableLink(): ApolloLink {
  return new ApolloLink(
    (operation: Operation) =>
      new Observable<FetchResult>((observer) => {
        const channel = getConsumer().subscriptions.create(
          { channel: 'GraphqlChannel' },
          {
            connected() {
              this.perform('execute', {
                query: print(operation.query),
                variables: operation.variables,
                operationName: operation.operationName,
              });
            },
            received(payload: { result: FetchResult; more: boolean }) {
              if (payload.result?.data || payload.result?.errors) {
                observer.next(payload.result);
              }
              if (!payload.more) {
                observer.complete();
              }
            },
          },
        );

        return () => channel.unsubscribe();
      }),
  );
}
